export default __webpack_public_path__ + "static/media/signature.10432224.svg";